const alignOverflowMenu = () => {
  const overflowMenu = document.querySelector('.overflow-menu');
  if (!overflowMenu) return;

  const align = () => {
    const moreButton = overflowMenu.shadowRoot?.querySelector('[part="more"]');
    if (!moreButton) return;

    const moreRect = moreButton.getBoundingClientRect();
    const menuRect = overflowMenu.getBoundingClientRect();
    const offsetLeft = moreRect.left - menuRect.left + 214;

    // Set via CSS variable, bukan inline style
    overflowMenu.style.setProperty('--overflow-panel-left', `${offsetLeft}px`);
  };

  overflowMenu.addEventListener('pointerenter', align);
  window.addEventListener('resize', align);
};

if (customElements.get('overflow-list')) {
  alignOverflowMenu();
} else {
  customElements.whenDefined('overflow-list').then(alignOverflowMenu);
}